import type { FunctionComponent } from 'react';
import { ProgramSummaryContent } from '../../../shared/view/ProgramSummaryContent/ProgramSummaryContent';

export const ProgramSummary: FunctionComponent = () => {
  return <ProgramSummaryContent />;
};
